var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c(_vm.currentComponet,{tag:"component",attrs:{"record":_vm.record},on:{"onEdit":_vm.handleEdit,"onGoBack":_vm.handleGoBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }